import type { Session } from '@supabase/supabase-js';

import { canAccessMainApp } from '../utils/authHelpers';
import { isPaperInboxLive } from './paperInbox';

export function canAccessPaperForward(session: Session | null): boolean {
    return canAccessMainApp(session);
}

export function shouldShowPaperForwardNavLink({
    session,
    isPublicLive = isPaperInboxLive(),
}: {
    session: Session | null;
    isPublicLive?: boolean;
}): boolean {
    return Boolean(isPublicLive) || canAccessPaperForward(session);
}
